import React from 'react';
import { motion } from 'framer-motion';

interface MicrophoneIndicatorProps {
  isRecording: boolean;
  isTranscribing: boolean;
  volume?: number; // 0-1 normalized
}

const NUM_BARS = 5;

const MicrophoneIndicator: React.FC<MicrophoneIndicatorProps> = ({ isRecording, isTranscribing, volume = 0 }) => {
  if (isTranscribing) {
    return (
      <div className="flex items-center justify-center gap-2 text-indigo-500">
        <motion.div
          animate={{ rotate: 360 }}
          transition={{ repeat: Infinity, duration: 1, ease: 'linear' }}
          className="w-5 h-5 border-2 border-indigo-500 border-t-transparent rounded-full"
        />
        <span className="text-sm font-medium">Checking...</span>
      </div>
    );
  }

  if (isRecording) {
    return (
      <div className="flex flex-col items-center gap-3">
        {/* Volume bars */}
        <div className="flex items-end justify-center gap-1 h-10">
          {Array.from({ length: NUM_BARS }).map((_, i) => {
            // Each bar has a different base height and responds to volume
            const barPosition = Math.abs(i - Math.floor(NUM_BARS / 2)); // 0 = center, higher = edges
            const sensitivity = 1 - barPosition * 0.2; // center bars more sensitive
            const barHeight = Math.max(6, volume * 40 * sensitivity);

            return (
              <div
                key={i}
                className="w-2 rounded-full bg-red-400 transition-all duration-100"
                style={{ height: `${barHeight}px` }}
              />
            );
          })}
        </div>
        <span className="text-sm font-medium text-red-500">Listening...</span>
      </div>
    );
  }

  return null;
};

export default MicrophoneIndicator;
